import './Categories.css'

import React, { useTransition } from 'react'
import { useHits } from 'react-instantsearch'

import localhostSettings from '../local' // adjust path as needed
import { useTranslation } from 'react-i18next'

interface CategoriesProps {
  selectedCategory: string | null
  setSelectedCategory: (category: string) => void
}

const Categories: React.FC<CategoriesProps> = ({ selectedCategory, setSelectedCategory }) => {
  const { hits } = useHits()
  const isRTL = localhostSettings.isRTL()
  const { t } = useTranslation();

  // Dynamically extract category labels based on lang

  const categories = hits
    .filter(hit => hit.addonSubTypeScope === 'ROAMING ADDON')
    .map(hit => {
      const subType = hit.category?.subType
      if (!subType) return null
      return {
        key: isRTL ? subType.valueAr : subType.valueEn,
        label: isRTL ? subType.valueAr : subType.valueEn
      }
    })
    .filter((cat): cat is { key: string; label: string } => !!cat)


  const uniqueCategories = categories.filter(
    (cat, index, self) => self.findIndex(c => c.key === cat.key) === index
  )


  const handleSelect = (category: string) => {
    if (selectedCategory === category) {
      setSelectedCategory('')
    } else {
      setSelectedCategory(category)
    }
  }

  return (
    <div className="categories">
      <div className='subtitle'>{t("What_are_you_looking_for")}</div>
      <div className="category-buttons">
        {uniqueCategories.map((cat) => (
          <button
            key={cat.key}
            className={`category-button ${selectedCategory === cat.key ? 'selected' : ''}`}
            onClick={() => handleSelect(cat.key)}
          >
            {cat.label}
          </button>
        ))}

      </div>
    </div>
  )
}

export default Categories
